import { createWebHistory, createRouter } from "vue-router"
import Home from "../components/Home" 
import Login from "../components/Login"
import OAuth2HomePage from "../components/OAuth2HomePage" 
import UnAuthorizedPage from "../components/UnAuthorizedPage" 
import TncErrorPopup from "../components/TncErrorPopup"
import Campaigns from "../components/Campaigns"
import AnalyticsLandingPage from "../components/AnalyticsLandingPage"
import Billing from "../components/Billing"
import CreateCampaign from "../components/CreateCampaign"
import SavedReports from '../components/SavedReports'
import AdvancedReports from '../components/AdvancedReports'
import SaveAndScheduleReport from '../components/SaveAndScheduleReport'
import ClickWrap from '../components/ClickWrap'
import StaticTnCPage from '../components/StaticTnCPage'
import Onboarding from '../components/self-serve/Onboarding'
import UserManagement from '../components/self-serve/UserManagement'
import LinkDelink from '../components/self-serve/LinkDelink'
import Link from '../components/self-serve/Link'
import Delink from '../components/self-serve/Delink'
import Approval from '../components/self-serve/Approval'
import AccountSelection from '../components/AccountSelection'
import {
  getLoggedSellerId, getTncAcceptance, getCookie
} from '../services/campaignService';
import DefaultReports from '../components/DefaultReports';

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/admin/select-account",
    name: "adminAccountSelection",
    component: AccountSelection,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/select-account",
    name: "accountSelection",
    component: AccountSelection,
    meta: {
      roles: ['AGENCY']
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/ads/auth/v1/external/login",
    name: "OAuth2HomePage",
    component: OAuth2HomePage,
  },
  {
    path: "/tncErrorPopup",
    name: "TncErrorPopup",
    component: TncErrorPopup,
  },
  {
    path: "/unauthorized",
    name: "UnAuthorizedPage",
    component: UnAuthorizedPage,
  },
  {
    path: "/admin/campaigns",
    name: "AdminCampaigns",
    component: Campaigns,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/campaigns",
    name: "Campaigns",
    component: Campaigns,
    meta: {
      roles: ['AGENCY', 'BRAND', 'SELLER']
    }
  },
  {
    path: "/admin/analytics",
    name: "AdminAnalytics",
    component: AnalyticsLandingPage,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: AnalyticsLandingPage,
    meta: {
      roles: ['AGENCY', 'BRAND', 'SELLER']
    }
  },
  {
    path: "/admin/billing",
    name: "Billing",
    component: Billing,
    meta: {
      roles: ['SUPERADMIN']
    }
  },
  {
    path: "/create-campaign",
    name: "createCampaign",
    component: CreateCampaign,
  },
  {
    path: "/admin/saved-reports",
    name: "adminSavedReports",
    component: SavedReports,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/saved-reports",
    name: "savedReports",
    component: SavedReports,
    meta: {
      roles: ['AGENCY', 'BRAND', 'SELLER']
    }
  },
  {
    path: "/advanced-reports",
    name: "advancedReports",
    component: AdvancedReports,
    meta: {
      roles: ['SUPERADMIN','OPS', 'AGENCY', 'BRAND', 'SELLER']
    }
  },
  {
    path: "/admin/default-reports",
    name: "defaultReports",
    component: DefaultReports,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/terms-and-conditions",
    name: "clickWrap",
    component: ClickWrap,
  },
  {
    path: "/StaticTnCPage",
    name: "StaticTnCPage",
    component: StaticTnCPage,
  },
  {
    path: "/admin/save-schedule-report",
    name: "adminSaveAndScheduleReport",
    component: SaveAndScheduleReport,
    meta: {
      roles: ['SUPERADMIN','OPS']
    }
  },
  {
    path: "/save-schedule-report",
    name: "saveAndScheduleReport",
    component: SaveAndScheduleReport,
    meta: {
      roles: ['AGENCY', 'BRAND', 'SELLER']
    }
  },
  {
    path: "/admin/onboarding",
    name: "onboarding",
    component: Onboarding,
    meta: {
      roles: ['SUPERADMIN', 'OPS']
    }
  },
  {
    path: "/admin/userManagement",
    name: "userManagement",
    component: UserManagement,
    meta: {
      roles: ['SUPERADMIN', 'OPS']
    }
  },
  {
    path: "/admin/requestApproval",
    name: "adminRequestApproval",
    component: LinkDelink,
    meta: {
      roles: ['SUPERADMIN']
    }
  },
  {
    path: "/requestApproval",
    name: "requestApproval",
    component: LinkDelink,
    meta: {
      roles: ['BRAND','SELLER']
    }
  },
  {
    path: "/link",
    name: "link",
    component: Link,
    meta: {
      roles: ['AGENCY']
    }
  },
  {
    path: "/delink",
    name: "delink",
    component: Delink,
    meta: {
      roles: ['AGENCY', 'BRAND','SELLER']
    }
  },
  {
    path: "/admin/approval",
    name: "Approval",
    component: Approval,
    meta: {
      roles: ['SUPERADMIN']
    }
  },
  { path: "/:pathMatch(.*)", component: Login, redirect: '/' }
]


const router = createRouter({
    history: createWebHistory(),
    routes
  })

router.beforeEach((to, from, next) => {
  let sellerId = getLoggedSellerId()
  let role = getCookie('role');
  let tncAcceptance = getTncAcceptance();
  if(role == 'AGENCY') {
    if(!!tncAcceptance && tncAcceptance === 'false' && to.name === 'clickWrap'){
      return next()
    } 
    if(!!tncAcceptance && tncAcceptance === 'false' && to.name !== 'clickWrap') {
      return next({ name: 'clickWrap'});
    }
  }
  if (to.name === 'Login' || to.name === 'OAuth2HomePage') {
    if (!!sellerId) {
      return next({ name: (role === 'SUPERADMIN' ||  role === 'OPS') ? 'AdminCampaigns' : 'Campaigns'});
    } else {
      return next();
    }
  }
  if (to.name === 'UnAuthorizedPage') {
    return next()
  }
  if (!getCookie('token')) {
    return next({ name: 'Login' });
  }
  if(to?.meta?.roles?.length && !to?.meta?.roles?.includes(role)) {
    return next({name: 'Login'})
  }
  if(to.name == 'onboarding' || to.name == 'userManagement' || to.name == 'Approval' || to.name == 'requestApproval' || 
    to.name == 'adminRequestApproval' || to.name == 'link' || to.name == 'delink' || to.name == 'Billing' || 
    to.name == 'accountSelection' || to.name == 'adminAccountSelection') 
      return next()
  
  if (!!sellerId) {
    let tncAcceptance = getTncAcceptance()
    if(role == 'BRAND' || role == 'SELLER') {
      if(!!tncAcceptance && tncAcceptance === 'false' && to.name === 'clickWrap'){
        return next()
      } 
      if(!!tncAcceptance && tncAcceptance === 'false' && to.name !== 'clickWrap') {
        return next({ name: 'clickWrap'});
      }
    }
    if (role === 'OPS' || role == 'SUPERADMIN' || role == 'AGENCY' || role == 'BRAND' || role == 'SELLER') {
      if (to.name === 'StaticTnCPage' || to.name === 'clickWrap') {
        return next({name: 'UnAuthorizedPage'})
      } else {
        return next()
      }
    }
    if (to.name === 'UnAuthorizedPage') {
      return next()
    }
  }

  sellerId = from.query.sellerId || getLoggedSellerId()
  if (!!sellerId) {
    next({ path: to.path })
  } else {
    next({ name: 'Login' });
  }
})


export default router